var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8291 10.8879C3.8291 9.92144 4.6126 9.13794 5.5791 9.13794H52.2458C53.2123 9.13794 53.9958 9.92144 53.9958 10.8879V45.8879C53.9958 46.8544 53.2123 47.6379 52.2458 47.6379H5.5791C4.6126 47.6379 3.8291 46.8544 3.8291 45.8879V10.8879ZM7.3291 12.6379V44.1379H50.4958V12.6379H7.3291Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1792 9.83804C4.7591 9.06484 5.85601 8.90814 6.6292 9.48804L28.9125 26.2005L51.1959 9.48804C51.9691 8.90814 53.066 9.06484 53.6459 9.83804C54.2258 10.6112 54.0691 11.7081 53.2959 12.288L29.9625 29.788C29.3403 30.2547 28.4848 30.2547 27.8625 29.788L4.5292 12.288C3.75601 11.7081 3.59931 10.6112 4.1792 9.83804Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8291 10.8879C3.8291 9.92144 4.6126 9.13794 5.5791 9.13794H28.9124C29.8789 9.13794 30.6624 9.92144 30.6624 10.8879C30.6624 11.8544 29.8789 12.6379 28.9124 12.6379H7.3291V28.3879C7.3291 29.3544 6.5456 30.1379 5.5791 30.1379C4.6126 30.1379 3.8291 29.3544 3.8291 28.3879V10.8879Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1624 10.8879C27.1624 9.92144 27.9459 9.13794 28.9124 9.13794H52.2458C53.2123 9.13794 53.9958 9.92144 53.9958 10.8879V28.3879C53.9958 29.3544 53.2123 30.1379 52.2458 30.1379C51.2793 30.1379 50.4958 29.3544 50.4958 28.3879V12.6379H28.9124C27.9459 12.6379 27.1624 11.8544 27.1624 10.8879Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.721d2490.svg";
export { ForwardRef as ReactComponent };